



























































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { AuthModule } from '@/store/Auth/AuthModule';
import { InstitutionsModule } from '@/store/Settings/InstitutionsModule';
import NewIntegration from '@/components/Settings/Institutions/Integrations/NewIntegration.vue';
import EditIntegration from '@/components/Settings/Institutions/Integrations/EditIntegration.vue';
import DeleteIntegration from '@/components/Settings/Institutions/Integrations/DeleteIntegration.vue';

@Component({ name: 'CardIntegrations', components: { NewIntegration, EditIntegration, DeleteIntegration } })
export default class extends SaascadaVue {

    integrationsPage = 1;
    headers = [
        { text: this.$t('pageText.institutions.fields.name'), width: "100%", sortable: false },
    ];

    get integrations() {
        return AuthModule.me.institution.config.cardIntegrations;
    }

    get loading() {
        return false;
    }

    get totalIntegrationsPages() {
        return 1;
    }

    get pageSize() {
        return InstitutionsModule.pageSize;
    }

    get currentIntegration() {
        return {id: ""};
        //return InstitutionsModule.currentIntegration;
    }

    async updateCurrentIntegration(integration: string) {
        // await InstitutionsModule.updateCurrentIntegration(payee);
    }

}
